module.exports = __webpack_public_path__ + "img/ic_mainservice_phone.7f61b692.svg";